import { Dropdown, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  BiSearchAlt,
  BiDotsHorizontal,
  BiTrash,
} from "react-icons/bi";
import { Status } from "../../components/Status";
import { Page, UserActions } from "./styles";
import { Load } from "../../components/Load";
import { api } from "../../services/api";
import { Empty } from "../../components/Empty";
import { PermissionComponent } from "../../components/PermissionComponent";
import { ModalCofirm } from "../../components/ModalCofirm";
export interface IUser {
  id: string;
  name: string;
  email: string;
  cpfCnpj: string;
  disabled: boolean;
  disabledAt: Date;
}
const Users = () => {
  const [searchOpen, setSearchOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<IUser[]>([]);
  const [userToDisable, setUserToDisable] = useState<IUser>({} as IUser);

  function handleToggleSearch() {
    setSearchOpen(!searchOpen);
  }
  function handleUserActionClick(user: IUser) {
    return (
      <UserActions>
        <PermissionComponent type="USER" caseType={1}>
          <li
            onClick={(ev) => {
              handleOpenDeleteUserModal(user);
            }}
          >
            <BiTrash />
            Desabilitar
          </li>
        </PermissionComponent>
      </UserActions>
    );
  }

  function handleOpenDeleteUserModal(user: IUser) {
    setUserToDisable(user);
  }
  function handleCloseDeleteUserModal() {
    setUserToDisable({} as IUser);
  }
  function handleDeleteUser() {
    api
      .post(`users/disable/${userToDisable.id}`)
      .then(() => {
        message.success("Usuário desativado com sucesso.");
        fetchData()
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => handleCloseDeleteUserModal());
  }
  function fetchData() {
    api
      .get<IUser[]>("users")
      .then((response) => {
        setUsers(response.data);
      })
      .catch((e) => {
        message.error(e.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(fetchData, []);
  return (
    <Page>
      {userToDisable.id && (
        <ModalCofirm
          title="Tem certeza que quer desabilitar esse usuário?"
          description="O mesmo não podera enviar mensagens."
          confirm={handleDeleteUser}
          cancel={handleCloseDeleteUserModal}
        />
      )}
      <header>
        <span>Usuários</span>
      </header>
      <div className="content">
        {loading ? (
          <div className="loading">
            <Load />
          </div>
        ) : (
            <table>
              <thead>
                <tr>
                  <th rowSpan={1} colSpan={3}>
                    Nome
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    CPF/CNPJ
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    Status
                  </th>
                  <th rowSpan={1} colSpan={1}>
                    Desabilitado em
                  </th>
                  <th></th>
                </tr>{" "}
              </thead>
              <tbody>
                {users.length ? (
                  users.map((user) => (
                    <>
                      <tr key={user.id}>
                        <td rowSpan={1} colSpan={3}>
                        <div style={{whiteSpace: 'break-spaces'}}>
                          {user.name}
                        </div>
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          {user.cpfCnpj}
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          <Status
                            title={
                              user.disabled
                                ? "INATIVO"
                                : "ATIVO"
                            }
                            type={
                              user.disabled
                                ? "INACTIVE"
                                : "ACTIVE"
                            }
                          />
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          {user.disabledAt ? new Date(user.disabledAt).toLocaleDateString() : ""}
                        </td>
                        <td rowSpan={1} colSpan={1}>
                          <Dropdown
                            overlay={() => {
                              return handleUserActionClick(user);
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                          >
                            <BiDotsHorizontal />
                          </Dropdown>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <tr>
                    <td rowSpan={1} colSpan={6}>
                      <Empty />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
        )}
      </div>
    </Page>
  );
};
export { Users };
